import * as types from "../actions/viewConciergeTypes.js";
import * as actions from "../actions/viewConciergeActions.js";

import { call, put, takeEvery } from 'redux-saga/effects';
import axiosInstance from '../../interceptor/interceptor.js'; 


const fetchConciergeApi = () =>  axiosInstance.get('emp/list/4'); 

function* fetchConcierges() {
  try {
    ////console.log("test");
    const response = yield call(fetchConciergeApi);
    ////console.log(response.data);
    yield put(actions.fetchConciergesSuccess(response.data.employees));
  } catch (error) {
    yield put(actions.fetchConciergesFailure(error.message));
  }
}

function* rootSaga() {
  yield takeEvery(types.FETCH_CONCIERGE_REQUEST, fetchConcierges);
}

export default rootSaga;
